import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  isUserAuthenticated as isUserAuthenticatedSelector,
  userHasAcceptedTerms as userHasAcceptedTermsSelector,
  getUserPermissionsData,
  isUserAdmin as isUserAdminSelector,
} from '../../selectors/users';
import Loading from '../Loading/Loading';
//component
import { Maintenance } from '../Maintenance';
import TermsAndConditionsPage from '../../pages/termsAndConditionsPage';
import AlertComponent from './AlertComponent';

const NEEDS_PERMISSION = 'No tenés permisos suficientes para ver esta opción.';

const PrivateRoute = ({ children, routeId, ...rest }) => {
  const isUserAuthenticated = useSelector(isUserAuthenticatedSelector);
  const user = useSelector((state) => state.auth.authData);
  const userHasAcceptedTerms = useSelector(userHasAcceptedTermsSelector);
  const userPermissions = useSelector(getUserPermissionsData);
  const isUserAdmin = useSelector(isUserAdminSelector);

  const checkActiveModuleAndPermission = () => {
    const permissions = userPermissions?.leftNavigationAndMenuButtons;
    if (!permissions) return { hasPermission: false, isModuleActive: false };
    let hasPermission = false;
    let isModuleActive = true;

    permissions.forEach((permission) => {
      if (permission.id === routeId) {
        hasPermission = isUserAdmin || permission['@_habilitado'];
        isModuleActive = permission.active;
      }
    });

    return {
      hasPermission,
      isModuleActive,
    };
  };

  const { hasPermission, isModuleActive } = checkActiveModuleAndPermission();
  const renderComponent = () => {
    if (!isUserAuthenticated) return null;
    if (!userHasAcceptedTerms) return <TermsAndConditionsPage user={user} />;
    if (!hasPermission) return <AlertComponent text={NEEDS_PERMISSION} />;
    if (!isModuleActive) return <Maintenance />;
    return null;
  };

  if (!(isUserAuthenticated && userHasAcceptedTerms && hasPermission && isModuleActive)) {
    return renderComponent();
  }

  return (
    <>
      <Helmet>
        <title>{rest.helmetTitle}</title>
      </Helmet>
      <Suspense fallback={<Loading />}>{children}</Suspense>
    </>
  );
};

export default PrivateRoute;
